import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from "@angular/router";
import { ObjectUtils } from "./common/utils/object-utils";

interface IRouteConfigData {
    disableRouteReuseOnChangedParam: string;
}

@Injectable()
export class RaskRouteReuseStrategy extends BaseRouteReuseStrategy {
    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        const data = this.getRouteData(future);
        if (ObjectUtils.hasValue(data?.disableRouteReuseOnChangedParam) &&
            future.paramMap.get(data.disableRouteReuseOnChangedParam) !== curr.paramMap.get(data.disableRouteReuseOnChangedParam)) {
            return false;
        }
        return super.shouldReuseRoute(future, curr);
    }

    private getRouteData(route: ActivatedRouteSnapshot): IRouteConfigData {
        return route.routeConfig && route.routeConfig.data as IRouteConfigData;
    }
}
